module.exports = __webpack_public_path__ + "img/trash-xmark.99033b9a.svg";